import React from "react";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import { useNavigate } from "react-router-dom";
import logo from "../assets/logo.svg";

export default function Navbar() {
    const navigate = useNavigate();

    return (
        <AppBar
            position="static"
            sx={{
                backgroundColor: "#1f3042",
                boxShadow: "0 2px 8px rgba(0,0,0,0.2)",
            }}
        >
            <Toolbar>
                <Box
                    component="img"
                    src={logo}
                    alt="Logo"
                    sx={{
                        height: 50,
                        cursor: "pointer",
                        marginRight: 2,
                    }}
                    onClick={() => navigate("/")}
                />
                <Typography
                    variant="h6"
                    sx={{ flexGrow: 1, fontWeight: 600, color: "white" }}
                >
                    
                </Typography>
            </Toolbar>
        </AppBar>
    );
}
